/**
 * Warehouse overview helpers — display only; no invented KPIs.
 */
import { availableQty, type MaterialItem } from '@/services/inventory'

export type StockFourQty = {
  physical: number
  reserved: number
  available: number
  incoming: number
}

/** Four inventory numbers already on MaterialItem / availableQty. */
export function stockFourQty(m: MaterialItem): StockFourQty {
  return {
    physical: m.onHand,
    reserved: m.reserved,
    available: availableQty(m),
    incoming: m.incoming,
  }
}

export function formatQtyWithUom(qty: number, uom: string): string {
  return `${qty.toLocaleString('vi-VN')} ${uom}`
}

export function countBelowThreshold(materials: MaterialItem[]): number {
  return materials.filter((m) => {
    const avail = availableQty(m)
    return avail < Math.max(m.min, m.safetyStock)
  }).length
}
